import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
const CheckboxUnchecked = forwardRef(({ ...props }, ref) => {
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-hidden": ariaHidden, ...props, children: _jsx("rect", { width: 15, height: 15, x: 0.5, y: 0.5, fill: "#fff", stroke: "#bbb", className: "CheckboxUnchecked-rect", rx: 3.5 }) }));
});
CheckboxUnchecked.displayName = 'CheckboxUnchecked';
export default CheckboxUnchecked;
//# sourceMappingURL=CheckboxUnchecked.js.map